import { boot } from "quasar/wrappers";
import { createProPlugin, inputs } from "@formkit/pro";
import { plugin, defaultConfig, createInput } from "@formkit/vue";
import { createAutoAnimatePlugin } from "@formkit/addons";
import { rootClasses } from "../../formkit.theme";
import { genesisIcons } from "@formkit/icons";
import { en, nb } from "@formkit/i18n";
import FormEditor from "src/components/FormEditor.vue";
import { FormKitNode } from "@formkit/core";
import { isValidPhoneNumber as externalIsValidPhoneNumber } from "libphonenumber-js";
import { autoAnimatePlugin } from "@formkit/auto-animate/vue";

const isValidPhoneNumber = (node: FormKitNode) => {
  if (!node.value) {
    return false;
  }

  // await node.input(new AsYouType().input(node.value as string));

  try {
    return externalIsValidPhoneNumber(node.value as string);
  } catch (err) {
    console.warn("Could not parse", err);
    return false;
  }
};

export default boot(async ({ app }) => {
  app.use(autoAnimatePlugin);

  const pro = createProPlugin("fk-5bd1f671f", inputs);
  app.use(
    plugin,
    defaultConfig({
      config: {
        rootClasses,
      },
      rules: {
        phone: isValidPhoneNumber,
      },
      inputs: {
        editor: createInput(FormEditor, {
          type: "input",
        }),
      },
      locales: { en, nb },
      icons: {
        ...genesisIcons,
      },
      plugins: [pro, createAutoAnimatePlugin()],
    }),
  );
});
